import React, { useEffect, useState } from "react";

import { fetchPunchPhotoApi } from "../api/timekeepingApi";

type Props = {
  token: string;
  punchId: string;
  title: string;
  /** Linhas de contexto abaixo da foto (hora, NSR, distância da loja...). */
  details?: string[];
  onClose: () => void;
};

/**
 * Selfie tirada pelo colaborador na marcação. Buscada pelo id da marcação com o
 * token do staff (a rota só responde a ADMIN e DP) e exibida como blob local.
 */
export default function PunchPhotoModal({ token, punchId, title, details = [], onClose }: Props) {
  const [url, setUrl] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;
    setUrl(null);
    setError(null);
    fetchPunchPhotoApi(token, punchId)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch((e: any) => !cancelled && setError(e?.message || "Erro ao abrir a foto da marcação."));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [token, punchId]);

  return (
    <div className="dpModalOverlay">
      <div className="dpModal dpTkPhotoModal">
        <header className="dpModal__header">
          <h2 className="dpModal__title">{title}</h2>
          <button className="dpModal__close" onClick={onClose} aria-label="Fechar">
            &times;
          </button>
        </header>
        <div className="dpModal__body">
          <div className="dpTkPhoto">
            {url ? <img src={url} alt="Foto tirada na marcação" /> : <span className="dpMuted">{error ?? "Carregando a foto..."}</span>}
          </div>
          {details.length ? (
            <ul className="dpTkPhoto__details">
              {details.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          ) : null}
        </div>
        <footer className="dpModal__footer">
          <button type="button" className="dpBtn dpBtn--secondary" onClick={onClose}>
            Fechar
          </button>
        </footer>
      </div>
    </div>
  );
}
